import * as ST from './styled';
import React, { useState } from 'react';
import linksData from './data.json';
import CallsComponent from '~/src/components/Footer/calls';
import LinksFooterComponent from '~/src/components/Footer/links';
import ButtonsBlockComponent from '~/src/components/Footer/buttonsBlock';
import EmailWidget from './emailWidget';
import CallRequestByTheme from '~/src/components/Popups/CallRequestByTheme';

export const Footer = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { city, withEmailWidget, emailWidgetText } = props;
  const handleClose = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      {withEmailWidget && <EmailWidget mainText={emailWidgetText} />}
      <ST.Footer>
        <ST.Wrap>
          <ST.FooterTop>
            <ST.ServiceLinksBlock>
              <LinksFooterComponent linksData={linksData} />
            </ST.ServiceLinksBlock>
            <ST.PersonalAreaBlock>
              <ST.SupportBlockMobile>
                <CallsComponent number={'+7 (495) 145 85 55, +7 (495) 803 37 77'} />
              </ST.SupportBlockMobile>
              <ST.ButtonsBlockContainer>
                <ButtonsBlockComponent />
              </ST.ButtonsBlockContainer>
            </ST.PersonalAreaBlock>
          </ST.FooterTop>
          <ST.FooterBottom>
            <ST.CopyrightBlock>
              <ST.CopyrightCompany>
                &copy; &laquo;Телеком Центр&raquo;, 2023
              </ST.CopyrightCompany>
            </ST.CopyrightBlock>
            <ST.SupportBlock>
              <CallsComponent
                handleClose={handleClose}
                number={'+7 (495) 145 85 55, +7 (495) 803 37 77'}
              />
            </ST.SupportBlock>
          </ST.FooterBottom>
        </ST.Wrap>
        <CallRequestByTheme
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          city={city}
          data-test='call-back-popup'
        />
      </ST.Footer>
    </>
  );
};
